import { render } from "./ApplyRefund.vue?vue&type=template&id=1df582a0"
import script from "./ApplyRefund.vue?vue&type=script&lang=js"
export * from "./ApplyRefund.vue?vue&type=script&lang=js"

import "./ApplyRefund.vue?vue&type=style&index=0&id=1df582a0&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__